import { Box, Flex, Link, useStyleConfig } from '@chakra-ui/react';
import {
  getSubmitButton, handleContinue,
} from '../utils';
import ButtonContainer from '../../Wrappers/ButtonContainer';
import AnsweredPersonalized from './AnsweredPersonalized';
import BackButton from './BackButton';

const PFSNav = (
  props,
  groupedQuestions,
  step,
  secOrIndIndex,
  isMultipart,
  isLastStep
) => {
  //JB Back and skip
  const sectionName = props.stateProps.sectionData.sectionName;
  let width = props.stateProps.sectionData.sectionName==='professional-experience'?'1000px':'800px';
  width = (sectionName === 'interview-sparl' || sectionName === 'interview-coach') ? '100%' : width;
  const sxe = { width: '100%', maxWidth: width, margin:'0 auto' } ;
  const variant = 'wrapper';
  const buttonStyles = useStyleConfig('Button', { variant });
  let backButton = '';
  if(!isLastStep) {
    backButton = BackButton(props, groupedQuestions, step,buttonStyles);
  }
  return (
    <Box className = 'pfsNav'>
      <Box sx={sxe}>
        {!isLastStep && AnsweredPersonalized(props)}
        <Flex
          sx={{
            justifyContent: 'space-between',
            flexDirection: ['column', 'row'],
          }}
        >
          {sectionName !== 'parser' && sectionName !== 'resumes' && sectionName !== 'new-aptitude' && sectionName !== 'grow-goals' && !sectionName.includes('interview') && sectionName !== 'professional-experience' && sectionName !== 'download' &&
          <Link
            sx={{
              fontSize: '16px',
              marginRight: '50px;',
              paddingTop: '2rem',
              height: '40px',
              color: 'NAVY',
              textDecoration: 'underline',
              _hover: {
                textDecoration: 'none',
                color: 'NAVY',
              },
            }}
            onClick={() => handleContinue(props, 'menu')}
          >
            Skip
          </Link>
          }
          {/*sectionName === 'download' &&
            <Button
              marginRight={[0, '24px']}
              marginTop={['12px', '2rem']}
              onClick={() => returnToPreviewFromRegenerate(props)}//onLink(false, props.formikProps, props.stateProps, 'preview')}
            >
              Backa
            </Button>
          */}
          <ButtonContainer>
            {backButton}
            {getSubmitButton(
              props,
              groupedQuestions,
              step,
              secOrIndIndex,
              isMultipart,
              isLastStep,
              buttonStyles
            )}
          </ButtonContainer>
        </Flex>
      </Box>
    </Box>
  );
};
export default PFSNav;
